import SplitPanel from './split-panel'
export * from './split-panel'
export default SplitPanel
